import firebase from 'firebase/app';
import '@firebase/firestore';
import '@firebase/functions';
import '@firebase/auth'

const config = {
  apiKey: "AIzaSyAMUWCrc46GfexcN06NSxuIxPQM0ElxNec",
  authDomain: "zoomryde.firebaseapp.com",
  databaseURL: "https://zoomryde.firebaseio.com",
  projectId: "zoomryde",
  storageBucket: "zoomryde.appspot.com",
  messagingSenderId: "656390974794"
};

firebase.initializeApp(config);

const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();

const currentUser = auth.currentUser;

const dbSettings = {

}

db.settings(dbSettings)

export {
	db, 
	auth, 
	firebase, 
	functions,
	currentUser
}